import type { Logger } from "winston";
import { browser } from '$app/environment';

let logger : Logger | undefined = undefined;

if (!browser) {
  // Server-side code
  import('./logger').then(mod => {
    logger = mod.logger;
  });
}

export function logDebug(message: string, error?: any | null, metaData?: object) {
  log("debug", message, error, metaData);
}

export function logInfo(message: string, error?: any | null, metaData?: object) {
  log("info", message, error, metaData);
}

export function logWarn(message: string, error?: any | null, metaData?: object) {
  log("warn", message, error, metaData);
}

export function logError(message: string, error?: any | null, metaData?: object) {
  log("error", message, error, metaData);
}

export function log(level: string, message: string, error?: any | null, metaData?: object) {
  if (logger) {
    if (error instanceof Error) {
      metaData = {
        ...metaData,
        error: {
          kind: error.name,
          stack: error.stack,
          message: error.message
        }
      };
    } else if (error) {
      metaData = {
        ...metaData,
        error: {
          kind: "Untyped error: " + typeof(error),
          message: error.toString()
        }
      }
    }
    logger.log({
      level: level,
      message: message,
      ...metaData
    });
  } else {
    if (level == "error") {
      console.error(message);
    } else if (level == "warn") {
      console.warn(message);
    } else if (level == "info") {
      console.info(message);
    } else if (level == "debug") {
      console.debug(message);
    } else {
      console.log(message);
    }
  }
}

export function isLogDebugEnabled() {
  if (logger) {
    return logger.isDebugEnabled();
  }
  return false;
}
